import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment-timezone';
import { MenuItem, MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { Paginator } from 'primeng/paginator';
import { AppSettings } from '../Constant/AppSettings';
import { ReportsService } from '../services/reports/reports.service';
import { UtilsService } from '../services/utils/utils.service';
import { CommonFunctions } from '../Utilities/CommonFunctions';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  @ViewChild('p', { static: false }) paginator?: Paginator;
  items: MenuItem[] = [{ label: 'Reports' }];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };
  isLoading: boolean = false;
  isExporting: boolean = false;

  paymentReportList: any[] = []
  clientEngagementReportList: any[] = []
  messageUsageReportList: any[] = []
  businessClientReportList: any[] = []

  totalAmount: any = 0;
  totalBusinesses: any = 0;
  //
  totalSmsSent: any = 0
  totalSmsReceived: any = 0
  totalAppointments: any = 0
  //
  totalNoOfCreditsAvailable: any = 0
  totalNoOfCreditsUsed: any = 0
  //
  totalInactiveBusinesses: any = 0
  totalActiveBusinesses: any = 0
  //
  totalAnnualRevenue: any = 0

  currentPosition: string = '';

  disabled: boolean = false;
  public innerWidth: any;
  //Paginator variable
  timer: any;
  pageSize: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;

  // PRIMENG variable
  cols: any[] = [];
  reports: any[] = [];
  selectedReport: any;
  startDate: any = '';
  endDate: any = '';
  showDateLayout: boolean = false;
  showNonDateLayout: boolean = false;
  showBusinessTypeLayout: boolean = false;
  reportsList: any[] = []
  businessTypes: any[] = [];
  selectedBusinessType: any = null;

  sortField: string = '';
  sortKey: string = '';
  sortDirection: string = 'ASC';

  constructor(
    public utils: UtilsService,
    private reportsService: ReportsService,
    private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.reports = [
      { name: 'Payment History Report', value: 'payment_history' },
      { name: 'Client Engagement Report', value: 'client_engagement' },
      { name: 'Message Usage Report', value: 'message_usage' },
      { name: 'Business Client Report', value: 'business_client' },
      { name: 'Business Type Report', value: 'business_type' },
    ];
    this.businessTypes = [
      { name: 'Free', value: 'FREE FOREVER' },
      { name: 'Basic', value: 'BASIC' },
      { name: 'Standard', value: 'STANDARD' },
    ];
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
    this.endDate = new Date();
  }

  getPaymentReports(currentPage: any) {
    this.showProgressBar();
    this.clearData()
    this.reportsService.getPaymentReports(currentPage, moment(this.startDate).format("YYYY-MM-DD"), moment(this.endDate).format("YYYY-MM-DD"), this.sortKey, this.sortField ? this.sortDirection : undefined).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get PaymentReports Response --->> ' + JSON.stringify(json));
        this.cols = [
          { field: 'businessName', header: 'Business Name', width: '30%', sortable: true },
          { field: 'shortname', header: 'Short Name', width: '20%', sortable: true },
          { field: 'paymentDate', header: 'Payment Date', width: '25%', sortable: true, sortKey: 'createdDate' },
          { field: 'paymentAmount', header: 'Payment Amount', width: '25%', sortable: true, sortKey: 'totalPrice' },
        ];
        if (json.response.status == 'SUCCESS') {
          this.paymentReportList = json.data.paymentHistoryReports.map((element: any) => this.mapPaymentRow(element));
          this.totalAmount = json.data.totalAmount
          this.totalBusinesses = json.data.totalBusinesses
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;
        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getClientEngagementReport(currentPage: any) {
    this.showProgressBar();
    this.clearData()
    this.reportsService.getClientEngagementReport(currentPage, moment(this.startDate).format("YYYY-MM-DD"), moment(this.endDate).format("YYYY-MM-DD"), this.sortKey, this.sortField ? this.sortDirection : undefined).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get ClientEngagementReport Response --->> ' + JSON.stringify(json));
        this.cols = [
          { field: 'businessName', header: 'Business Name', width: '25%', sortable: true, sortKey: 'name' },
          { field: 'shortname', header: 'Short Name', width: '15%', sortable: true, sortKey: 'shortName' },
          { field: 'noOfSmsSent', header: 'No Of SMS/MMS Sent', width: '20%', sortable: true },
          { field: 'noOfSmsReceived', header: 'No Of SMS/MMS Received', width: '20%', sortable: true },
          { field: 'noOfAppointments', header: 'No Of Appointments', width: '20%', sortable: true },
        ];
        if (json.response.status == 'SUCCESS') {
          this.paymentReportList = json.data.clientEngagementReports.map((element: any) => this.mapClientEngagementRow(element));
          this.totalBusinesses = json.data.totalBusinesses
          this.totalSmsSent = json.data.totalSmsSent
          this.totalSmsReceived = json.data.totalSmsReceived
          this.totalAppointments = json.data.totalAppointments
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;

        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getMessageUsageReport(currentPage: any) {
    this.showProgressBar();
    this.clearData()
    this.reportsService.getMessageUsageReport(currentPage, this.sortKey, this.sortField ? this.sortDirection : undefined).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get MessageUsageReport Response --->> ' + JSON.stringify(json));
        this.cols = [
          { field: 'businessName', header: 'Business Name', width: '30%', sortable: true, sortKey: 'name' },
          { field: 'shortname', header: 'Short Name', width: '20%', sortable: true, sortKey: 'shortName' },
          { field: 'creditsUsed', header: 'Credits Used', width: '25%', sortable: true },
          { field: 'creditsAvailable', header: 'Credits Available', width: '25%', sortable: true },
        ];
        if (json.response.status == 'SUCCESS') {
          this.paymentReportList = json.data.messageUsageReports.map((element: any) => this.mapMessageUsageRow(element));
          this.totalBusinesses = json.data.totalBusinesses
          this.totalNoOfCreditsAvailable = json.data.totalNoOfCreditsAvailable
          this.totalNoOfCreditsUsed = json.data.totalNoOfCreditsUsed
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;

        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getBusinessClientReports(currentPage: any) {
    this.showProgressBar();
    this.clearData()
    this.reportsService.getBusinessClientReports(currentPage, moment(this.startDate).format("YYYY-MM-DD"), moment(this.endDate).format("YYYY-MM-DD"), this.sortKey, this.sortField ? this.sortDirection : undefined).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get BusinessClientReport Response --->> ' + JSON.stringify(json));
        this.cols = [
          { field: 'businessName', header: 'Business Name', width: '14%', sortable: true, sortKey: 'name' },
          { field: 'shortName', header: 'Short Name', width: '10%', sortable: true, sortKey: 'shortName' },
          { field: 'website', header: 'Website', width: '14%', sortable: true, sortKey: 'website' },
          { field: 'phone', header: 'Phone', width: '12%', sortable: true, sortKey: 'phone' },
          { field: 'einno', header: 'EIN', width: '10%', sortable: true, sortKey: 'einNo' },
          { field: 'status', header: 'Status', width: '10%', sortable: true, sortKey: 'isActive' },
          { field: 'registeredOn', header: 'Registered On', width: '12%', sortable: true, sortKey: 'registrationDate' },
          { field: 'subscriptionPlan', header: 'Subscription Plan', width: '10%' },
          { field: 'expiry', header: 'Expiry Date', width: '8%' },
        ];
        if (json.response.status == 'SUCCESS') {
          this.paymentReportList = json.data.businessClientReports.map((element: any) => this.mapBusinessClientRow(element));
          this.totalBusinesses = json.data.totalBusinesses
          this.totalInactiveBusinesses = json.data.totalInactiveBusinesses
          this.totalActiveBusinesses = json.data.totalActiveBusinesses
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;

        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getBusinessTypeReport(currentPage: any) {
    this.showProgressBar();
    this.clearData()
    this.reportsService.getBusinessTypeReport(currentPage, this.selectedBusinessType,
      moment(this.startDate).format("YYYY-MM-DD"), moment(this.endDate).format("YYYY-MM-DD"), this.sortKey, this.sortField ? this.sortDirection : undefined).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get BusinessTypeReport Response --->> ' + JSON.stringify(json));
        this.cols = [
          { field: 'businessName', header: 'Business Name', width: '24%', sortable: true },
          { field: 'subscriptionType', header: 'Subscription Type', width: '12%' },
          { field: 'subscriptionAmount', header: 'Subscription Amount', width: '16%', sortable: true },
          { field: 'setupFee', header: 'Setup Fee', width: '14%', sortable: true },
          { field: 'messageCreditAmount', header: 'Message Credit Amount', width: '18%', sortable: true },
          { field: 'revenue', header: 'Total', width: '16%', sortable: true },
        ];
        if (json.response.status == 'SUCCESS') {
          this.paymentReportList = json.data.businessTypeReports.map((element: any) => this.mapBusinessTypeRow(element));
          this.totalBusinesses = json.data.totalBusinesses
          this.totalAnnualRevenue = json.data.totalAnnualRevenue
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;
        } else {
          this.showErrorToastMsg(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  private mapPaymentRow(element: any) {
    return {
      businessId: element.businessId,
      paymentId: element.paymentId,
      businessName: element.businessName,
      shortname: element.shortname,
      paymentDate: moment(element.paymentDate).format('Do MMMM YYYY'),
      paymentAmount: '$ ' + element.paymentAmount,
    };
  }

  private mapClientEngagementRow(element: any) {
    return {
      businessName: element.businessName,
      shortname: element.shortname,
      noOfSmsSent: element.noOfSmsSent,
      noOfSmsReceived: element.noOfSmsReceived,
      noOfAppointments: element.noOfAppointments,
    };
  }

  private mapMessageUsageRow(element: any) {
    return {
      businessId: element.businessId,
      businessName: element.businessName,
      shortname: element.shortname,
      creditsUsed: element.creditsUsed,
      creditsAvailable: element.creditsAvailable || 0,
    };
  }

  private mapBusinessClientRow(element: any) {
    return {
      businessName: element.businessName,
      shortName: element.shortName,
      website: element.website,
      phone: element.phone,
      registeredOn: moment(element.registeredOn).format('Do MMMM YYYY'),
      status: element.status,
      einno: element.einno,
      subscriptionPlan: element.subscriptionPlan || 'N/A',
      expiryDate: element.expiry || null,
      expiry: element.expiry ? moment(element.expiry).format('Do MMMM YYYY') : 'N/A',
    };
  }

  private mapBusinessTypeRow(element: any) {
    return {
      businessName: element.businessName,
      subscriptionType: element.subscriptionType,
      subscriptionAmount: '$ ' + (element.subscriptionAmount || 0),
      setupFee: '$ ' + (element.setupFee || 0),
      messageCreditAmount: '$ ' + (element.messageCreditAmount || 0),
      revenue: '$ ' + (element.revenue || 0),
    };
  }

  exportToExcel() {
    if (this.currentPosition == '' || this.isExporting) {
      return;
    }
    if (this.totalCount === 0) {
      this.showErrorToastMsg('No data to export');
      return;
    }
    this.isExporting = true;
    this.reportsService.exportReport(this.currentPosition, moment(this.startDate).format("YYYY-MM-DD"), moment(this.endDate).format("YYYY-MM-DD"), this.currentPosition === 'business_type' ? this.selectedBusinessType : undefined).subscribe(
      (response: HttpResponse<Blob>) => {
        this.downloadExcelBlob(response);
        this.isExporting = false;
      },
      (error) => {
        console.log(error);
        this.showErrorToastMsg(AppSettings.ERROR_MSG);
        this.isExporting = false;
      }
    );
  }

  private downloadExcelBlob(response: HttpResponse<Blob>) {
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'Report.xlsx';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        fileName = match[1];
      }
    }

    const url = URL.createObjectURL(response.body as Blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  generateReport() {
    if (this.selectedReport == 'business_type' && !this.selectedBusinessType) {
      this.showErrorToastMsg('Please select a business type');
      return;
    }
    this.currentPosition = this.selectedReport;
    this.sortField = '';
    this.sortKey = '';
    this.sortDirection = 'ASC';
    this.paginator?.changePage(0);
  }

  onSortColumn(col: any) {
    if (!col.sortable) {
      return;
    }
    if (this.sortField == col.field) {
      this.sortDirection = this.sortDirection == 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortField = col.field;
      this.sortKey = col.sortKey || col.field;
      this.sortDirection = 'ASC';
    }
    this.currentPage = 1;
    this.paginator?.changePage(0);
    this.loadCurrentReport();
  }

  getExpiryRowClass(report: any): string {
    if (this.currentPosition != 'business_client' || !report.expiryDate) {
      return '';
    }
    const daysToExpiry = moment(report.expiryDate).startOf('day').diff(moment().startOf('day'), 'days');
    if (daysToExpiry < 0) {
      return 'row-expiry-red';
    }
    if (daysToExpiry <= 30) {
      return 'row-expiry-yellow';
    }
    return 'row-expiry-green';
  }


  showProgressBar() {
    this.messageService.clear();
    this.isLoading = true;
    this.disabled = true;
  }

  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }

  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }

  showMessage(severity: string, msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: severity,
      detail: msg,
    });
  }

  showErrorToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      summary: 'Error',
      detail: msg,
    });
  }

  showSuccessToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'success',
      summary: 'Success',
      detail: msg,
    });
  }

  onFilterValueChange(event: any) {
    console.log(this.selectedReport)
    this.selectedBusinessType = null;
    this.currentPosition = '';
    this.sortField = '';
    this.sortKey = '';
    this.sortDirection = 'ASC';
    this.pageSize = 0;
    this.totalCount = 0;
    this.clearData();
    if (this.selectedReport != null && this.selectedReport != 'null') {
      if(this.selectedReport == 'message_usage'){
        this.showNonDateLayout = true;
        this.showDateLayout = false;
        this.showBusinessTypeLayout = false;
      }else if(this.selectedReport == 'business_type'){
        this.showBusinessTypeLayout = true;
        this.showNonDateLayout = false;
        this.showDateLayout = true;
      }else{
        this.showDateLayout = true;
        this.showNonDateLayout = false;
        this.showBusinessTypeLayout = false;
      }
    } else {
        this.showNonDateLayout = false;
        this.showDateLayout = false;
        this.showBusinessTypeLayout = false;
    }
    this.currentPage = 1;
  }

  onDateChange(event: any, type: string) {
    // this.checkConflict(type);
  }

  clearData() {
    this.paymentReportList = []
    this.totalAmount = 0;
    this.totalBusinesses = 0;
    //
    this.totalSmsSent = 0
    this.totalSmsReceived = 0
    this.totalAppointments = 0
    //
    this.totalNoOfCreditsAvailable = 0
    this.totalNoOfCreditsUsed = 0
    //
    this.totalInactiveBusinesses = 0
    this.totalActiveBusinesses = 0
    //
    this.totalAnnualRevenue = 0
  }

  showHideModalDialog(type: string) {
    switch (type) {
      // case 'edit_client':
      //   this.headerName = 'Edit Business';
      //   this.displayAddEditModal = !this.displayAddEditModal;
      //   break;
      // case 'add_client':
      //   this.clearFormData();
      //   this.headerName = 'Add Business';
      //   this.displayAddEditModal = !this.displayAddEditModal;
      //   break;
      // case 'assign_client':
      //   this.headerName = 'Assign Twillio Number';
      //   this.displayChangeModal = !this.displayChangeModal;
      //   break;
    }
  }

  keyPressAlphaNumericWithCharacters(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  toISOStringLocal(d: any) {
    console.log('date:', d)
    function z(n: any) { return (n < 10 ? '0' : '') + n }
    return d == '' ? '' : d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' +
      z(d.getDate()) + 'T' + z(d.getHours()) + ':' +
      z(d.getMinutes()) + ':' + z(d.getSeconds())
  }

  toISOStringLocalWithFixTime(d: any) {
    console.log(d)
    function z(n: any) { return (n < 10 ? '0' : '') + n }
    var today = new Date();
    var hour, minute, second;
    if (CommonFunctions.isToday(new Date(d))) {
      hour = today.getHours();
      minute = today.getMinutes();
      second = today.getSeconds();
    } else {
      hour = 23;
      minute = 59;
      second = 59;
    }
    return d == '' ? '' : d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' +
      z(d.getDate()) + 'T' + z(hour) + ':' +
      z(minute) + ':' + z(second)
  }

  showDialogMaximized(event: any, dialog: Dialog) {
    if (this.innerWidth <= 640) {
      dialog.maximized = true;
    }
  }

  paginate(event: any) {
    console.log(event)
    this.currentPage = event.page + 1;
    this.loadCurrentReport();
  }

  private loadCurrentReport() {
    switch (this.selectedReport) {
      case 'payment_history':
        this.getPaymentReports(this.currentPage)
        break;
      case 'client_engagement':
        this.getClientEngagementReport(this.currentPage)
        break;
      case 'message_usage':
        this.getMessageUsageReport(this.currentPage)
        break;
      case 'business_client':
        this.getBusinessClientReports(this.currentPage)
        break;
      case 'business_type':
        this.getBusinessTypeReport(this.currentPage)
        break;
    }
  }
  get state(): string {
    return this.utils.state;
  }
}
